import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Impressum from './Impressum';
import Shop from './pages/Shop';
import Product from './pages/Product';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Cart from './components/Cart';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <CartProvider>
                <Header />
                <Cart />
                <Routes>
                    <Route path="/" element={<App />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:handle" element={<Product />} />
                </Routes>
            </CartProvider>
        </BrowserRouter>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
